import { Suspense } from "react";
import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { DocLoadingExcerpt } from "./doc-frame";
import { LazyDocReadOnlyView } from "./doc-editor.lazy";

/**
 * A Doc inside a conversation: the read-only view, never a second live
 * editor for a frame that may be open on the canvas.
 */
export function DocEmbedFrame({ data }: FrameProps) {
  return (
    <Suspense fallback={<DocLoadingExcerpt data={data} />}>
      <LazyDocReadOnlyView
        frameType={data.frameType}
        content={data.content ?? {}}
      />
    </Suspense>
  );
}
